import { z } from "zod";
import { PublicIdSchema } from "./common";

export const OrderTimelineEvent = z.object({
  // #508: dispatch_* はレーン確定/解除 (route.confirm / plan.confirm 等) 由来のイベント。
  type: z.enum([
    "created",
    "updated",
    "status_updated",
    "dispatch_confirmed",
    "dispatch_unconfirmed",
    "unknown",
  ]),
  description: z.string(),
  occurred_at: z.iso.datetime({ offset: true }),
  actor: z.object({
    public_id: PublicIdSchema.nullable(),
    name: z.string(),
  }),
});

export type OrderTimelineEventDto = z.infer<typeof OrderTimelineEvent>;
